export default __webpack_public_path__ + "static/media/foliage@2x.62f066b8.png";